export default __webpack_public_path__ + "2bdb6a1f7042caeb3d4528047ddf8268.svg";